export default __webpack_public_path__ + "static/media/redo.ef48d4b7.svg";